import { useEffect } from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';

export function useRedirectOnResolveError({ error, redirectPath }) {
  const history = useHistory();

  useEffect(() => {
    if (!error) {
      return;
    }

    if (error.status === 404) {
      history.replace(redirectPath);
    }
  }, [error]);
}
